import { render, staticRenderFns } from "./Contenu.vue?vue&type=template&id=33cbc888&scoped=true"
import script from "./Contenu.vue?vue&type=script&lang=js"
export * from "./Contenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cbc888",
  null
  
)

export default component.exports